import { Component, Input } from '@angular/core';
import { EquivalentCard } from '../../models/equivalentCard';

@Component({
    selector: 'app-impact-equivalent-card',
    templateUrl: './impact-equivalent-card.component.html',
    styleUrl: './impact-equivalent-card.component.scss',
    standalone: false
})
export class ImpactEquivalentCardComponent {
  @Input() item!: EquivalentCard;
}
